import { action } from 'easy-peasy';
import { IActionArchiveProgramAssistant } from '../types';

const archiveProgramAssistant: IActionArchiveProgramAssistant = action((state, localAdminId) => {
  const updatedList = state.list.filter(item => item.id !== localAdminId);

  state.list = updatedList;
});

export default archiveProgramAssistant;
